<script>
import { Bar } from 'vue-chartjs'


export default Bar.extend({
  name: 'horizontal-bar-chart',
  /**
   *
   * @returns {{options: {responsive: boolean, responsiveAnimationDuration: number, legend: {display: boolean}, scales: {xAxes: [*], yAxes: [*]}}}}
   */
  data() {
    return {
      options: {
        responsive: false,
        responsiveAnimationDuration: 0,
        legend: {
          display: !!this.settings.legend,
          position: 'bottom',
          labels: {
            fontSize: 40,
            boxWidth: 100,
            padding: 20,
          },
        },
        scales: {
          xAxes: [{
            ticks: {
              beginAtZero: true,
              fontSize: 40,
              offset: true,
            },
          }],
          yAxes: [{
            ticks: {
              maxTicksLimit: 8,
              fontFamily: '"Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif',
              fontSize: 40,
            },
          }],
        },
        animation: {
          duration: 0,
          onComplete: function () {
            let chartInstance = this.chart
            let ctx = chartInstance.ctx
            let datasets = this.data.datasets

            ctx.font = Chart.helpers.fontString(35, 35, Chart.defaults.global.defaultFontFamily)
            ctx.textAlign = 'center'
            ctx.textBaseline = 'bottom'


            const maxValue = Math.max(...datasets.map(el => {
              return Math.max(...el.data)
            }))

            const minValue = Math.min(...datasets.map(el => {
              return Math.min(...el.data)
            }))

            const ticks = chartInstance.scales['y-axis-0'].ticksAsNumbers
            const yRange = Math.max(...ticks) - Math.min(...ticks)

            let yScale = chartInstance.scales["y-axis-0"]
            let yZero = yScale.getPixelForValue(0)

            datasets.forEach(function (dataset, i) {
              const meta = chartInstance.controller.getDatasetMeta(i)
              meta.data.forEach(function (bar, index) {
                const data = dataset.data[index]
                let labelConfig = null
                const currentAxisRatio = Math.abs(data > 0 ? maxValue : minValue) / yRange
                const currentDataToAxisRatio = Math.abs(data) / yRange
                if (
                    (currentAxisRatio <= .2)
                    || (currentAxisRatio <= .3 && currentDataToAxisRatio < .19)
                ) {
                  labelConfig = {
                    color: '#333',
                    y: yZero - (data > 0 ? -55 : 5),
                  }
                } else if (currentDataToAxisRatio >= .19) {
                  labelConfig = {
                    color: '#fff',
                    verticalOffset: data > 0 ? 55 : -5,
                  }
                } else {
                  labelConfig = {
                    color: '#333',
                    verticalOffset: data < 0 ? 55 : -5,
                  }
                }


                ctx.fillStyle = labelConfig.color
                ctx.fillText(
                    data.toFixed(2).replace('.', ','),
                    bar._model.x,
                    labelConfig.y ? labelConfig.y : bar._model.y + labelConfig.verticalOffset,
                )
              })
            })
            ctx.lineWidth = 2
            ctx.beginPath()
            ctx.moveTo(60, yZero)
            ctx.lineTo(chartInstance.width, yZero)
            ctx.strokeStyle = "rgba(169,169,169, .6)"
            ctx.stroke()
          },
        },
      },
    }
  },

  props: ['chartData', 'settings'],

  mounted() {
    this.renderChart(this.chartData, this.options)
    setTimeout(() => {
      this.$emit('generateChartImage', this._chart.toBase64Image())
    }, 2000)
  },
})
</script>



// WEBPACK FOOTER //
// ChartVerticalBar.vue?654f1566